var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Success",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7222 8.5L16.9998 0L2.27734 8.5V25.5L16.9998 34L31.7222 25.5V8.5ZM22.8009 10.3177L25.4177 10.2L25.3 12.8168L16.8097 21.3071L16.8115 21.3089L14.3125 23.8079L14.3106 23.8061L14.31 23.8068L11.8109 21.3077L11.8116 21.3071L8.69876 18.1942L8.58104 15.5775L11.1978 15.6952L14.3106 18.808L22.8009 10.3177Z",
    fill: "#93ECC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBanner);
export default __webpack_public_path__ + "static/media/SuccessBanner.8143e306a328fa9de5814c0232771e28.svg";
export { ForwardRef as ReactComponent };